// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 14) return "static/js/4219158c552a08a51465.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"3e51fc71c8882aede92d","211":"cf3283993c5c0a5fc904","212":"13f132dac8cfdcd49389"}[chunkId] + ".chunk.js";
};